import React from 'react';
import toast from 'react-hot-toast';
import { X } from 'lucide-react';
import type { ProductLeaf, SectionPath } from '../../utils/tree';
import { IdBadge, IdBadgeType } from '../../../../../components/ui/badge/IdBadge';

interface LeafProductCellProps {
  leaf: ProductLeaf;
  parentPath: SectionPath;
  childIndex: number;
  disabled: boolean;
  onRemove: (parentPath: SectionPath, childIndex: number) => void;
}

export const LeafProductCell: React.FC<LeafProductCellProps> = ({
  leaf,
  parentPath,
  childIndex,
  disabled,
  onRemove,
}) => {
  const copySkuToClipboard = () => {
    if (!leaf.sku) return;
    void navigator.clipboard.writeText(leaf.sku).catch(() => undefined);
    toast.success(`Copied SKU ${leaf.sku}`);
  };
  return (
    <div className="pgte-sku-wrap">
      <button
        type="button"
        className="pgte-leaf-clear"
        onClick={() => onRemove(parentPath, childIndex)}
        disabled={disabled}
        title="Remove this product"
        aria-label="Remove this product"
      >
        <X size={14} />
      </button>
      <span onClick={copySkuToClipboard}>
        <IdBadge type={IdBadgeType.SKU} value={leaf.sku} size="sm" showCopyIcon stopPropagation />
      </span>
      {leaf.productName && (
        <span className="pgte-product-name flex-grow-1" title={leaf.productName}>
          {leaf.productName}
        </span>
      )}
    </div>
  );
};
